import { render, staticRenderFns } from "./UploaderFiles.vue?vue&type=template&id=50352934&scoped=true&lang=true&"
import script from "./UploaderFiles.vue?vue&type=script&lang=js&"
export * from "./UploaderFiles.vue?vue&type=script&lang=js&"
import style0 from "./UploaderFiles.vue?vue&type=style&index=0&id=50352934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50352934",
  null
  
)

export default component.exports